import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Home, Droplets, SprayCan, Sparkles, Building, Square, Fence, Car } from 'lucide-react';
import { services, serviceAreas } from '../mockData';

const iconMap = {
  'home': Home,
  'droplets': Droplets,
  'spray-can': SprayCan,
  'sparkles': Sparkles,
  'building': Building,
  'square': Square,
  'fence': Fence,
  'car': Car
};

const Services = () => {
  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="!text-xl text-gray-600">

          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="border-2 border-gray-200"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <IconComponent className="h-7 w-7 text-green-700" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {service.title}
                  </CardTitle>
                  <div className="flex gap-2 mt-2">
                    {service.residential && (
                      <Badge variant="secondary" className="bg-green-50 text-green-700">
                        Residential
                      </Badge>
                    )}
                    {service.commercial && (
                      <Badge variant="secondary" className="bg-blue-50 text-blue-700">
                        Commercial
                      </Badge>
                    )}
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Service Areas Section */}
        <div className="mt-16 bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-100">
          <div className="text-center max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Areas We Service
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {serviceAreas.map((area, index) => (
                <div key={index} className="bg-white rounded-lg p-3 shadow-sm border border-green-100">
                  <p className="text-gray-700 font-medium">{area}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default Services;